/* eslint-disable no-param-reassign */
import angular from 'angular';

import * as actions from '../../../store/actions';

const mapStateToScope = (state) => ({
  currentMedia: state.media,
  user: state.user.user,
  pet: state.pet.pet,
});

angular
  .module('myConsultApp')
  .controller('mediaDetailController', ($ngRedux, $scope, $rootScope, $location, $http, ENV, $interval) => {
    $scope.init = () => {
      $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
    };

    $scope.onClose = () => {
      $rootScope.closeComponent().then(() => {
        if ($location.$$url.startsWith('/admin/media/manage-media')) {
          $scope.setActiveUser({});
          $scope.setActivePet({});
          $rootScope.userId = null;
        }
      });
    };

    $scope.doRetryMediaFile = (mediaId) => {
      $scope.retryMediaFile($http, ENV, mediaId)
        .then((response) => {
            $scope.pollMediaRetryFile();
        })
        .catch((err) => {
          console.warn(err);
        });
    };

    const mediaListener = $scope.$watch('currentMedia', (current, previous) => {
      if (!current || angular.equals(current, previous)) return;

      const petId = current?.activeMedia?.[0]?.pets?.[0]?.id;
      const activityId = current?.activeMedia?.[0]?.['user-activities']?.[0]?.id;

      if (!petId && activityId) {
        const userId = current.activeMedia[0].user.id;
        $scope
          .getUserActivity($http, ENV, userId, activityId)
          .then((response) => {
            const newPetId = response['user-activities']?.pets?.[0]?.id;
            if (newPetId) {
              $scope.getPet($http, ENV, newPetId).catch((err) => {
                console.warn(err);
              });
            }
          })
          .catch((err) => {
            console.warn(err);
          });
      } else if (petId) {
        $scope.getPet($http, ENV, petId).catch((err) => {
          console.warn(err);
        });
      }
    });

    let mediaRetryPromise;
    $scope.pollMediaRetryFile = () => {
      // if promise exists, cancel it to prevent duplication of intervals
      if (angular.isDefined(mediaRetryPromise)) {
        $interval.cancel(mediaRetryPromise);
        mediaRetryPromise = undefined;
      }
      mediaRetryPromise= $interval(() => {
        $scope.getMediaRetryFile();
      }, 6000);
    }

    $scope.getMediaRetryFile = () => {
      $scope
      .getMediaInfo($http, ENV, $scope.currentMedia.activeMedia[0].id)
      .then((res) => {
        $scope.$apply(() => {
          $scope.currentMedia.activeMedia[0] = res;
          $scope.checkMediaRetryFile();
        });
      });
    };

    $scope.checkMediaRetryFile = () => {
      if (!$scope.currentMedia.activeMedia[0].file_name){
        $scope.pollMediaRetryFile();
      } else if ($scope.currentMedia.activeMedia[0].file_name) {
        $interval.cancel(mediaRetryPromise);
      }
    }

    $scope.init();

    $scope.$on('$destroy', () => {
      $scope.unsubscribe();
      $interval.cancel(mediaRetryPromise);
      mediaListener();
    });
  })
  .directive('mediaDetail', () => {
    return {
      templateUrl: 'templates/v2/media-detail.html',
    };
  });
